/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pool_Standard_RunInputs */

const bn_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্ট্যান্ডার্ড রান`)
};

const de_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardlauf`)
};

const el_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τυπικό τρέξιμο`)
};

const en_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard Run`)
};

const es_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecución estándar`)
};

const fr_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partie standard`)
};

const hi_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मानक रन`)
};

const hu_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szabványos futás`)
};

const id_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalankan Standar`)
};

const it_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corsa standard`)
};

const ja_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準実行`)
};

const ko_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`표준 실행`)
};

const nl_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standaard uitvoering`)
};

const pl_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bieg standardowy`)
};

const pt_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Execução Padrão`)
};

const ru_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стандартный запуск`)
};

const sv_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardkörning`)
};

const tr_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standart Çalıştırma`)
};

const uk_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стандартний запуск`)
};

const vi_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chạy tiêu chuẩn`)
};

const zh_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标准运行`)
};

const zh_hant_pool_standard_run = /** @type {(inputs: Pool_Standard_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準運行`)
};

/**
* | output |
* | --- |
* | "Standard Run" |
*
* @param {Pool_Standard_RunInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const pool_standard_run = /** @type {((inputs?: Pool_Standard_RunInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pool_Standard_RunInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_pool_standard_run(inputs)
	if (locale === "de") return de_pool_standard_run(inputs)
	if (locale === "el") return el_pool_standard_run(inputs)
	if (locale === "en") return en_pool_standard_run(inputs)
	if (locale === "es") return es_pool_standard_run(inputs)
	if (locale === "fr") return fr_pool_standard_run(inputs)
	if (locale === "hi") return hi_pool_standard_run(inputs)
	if (locale === "hu") return hu_pool_standard_run(inputs)
	if (locale === "id") return id_pool_standard_run(inputs)
	if (locale === "it") return it_pool_standard_run(inputs)
	if (locale === "ja") return ja_pool_standard_run(inputs)
	if (locale === "ko") return ko_pool_standard_run(inputs)
	if (locale === "nl") return nl_pool_standard_run(inputs)
	if (locale === "pl") return pl_pool_standard_run(inputs)
	if (locale === "pt") return pt_pool_standard_run(inputs)
	if (locale === "ru") return ru_pool_standard_run(inputs)
	if (locale === "sv") return sv_pool_standard_run(inputs)
	if (locale === "tr") return tr_pool_standard_run(inputs)
	if (locale === "uk") return uk_pool_standard_run(inputs)
	if (locale === "vi") return vi_pool_standard_run(inputs)
	if (locale === "zh") return zh_pool_standard_run(inputs)
	return zh_hant_pool_standard_run(inputs)
});